module.exports = __webpack_public_path__ + "5c436a00da010ff0ed564e36fa75eb17.svg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/tr/2.svg
// module id = 645
// module chunks = 0